// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_status/delete
 *
 * Action endpoint — emits an empty success envelope (no dados payload).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DespesasStatus_DeleteResponseDados = null;

export type DespesasStatus_DeleteResponse = ApiResponse<DespesasStatus_DeleteResponseDados>;

registerResponseContract('DespesasStatus_DeleteResponse', {})
